import React from 'react';
import Nav from './Nav/Nav';
import ChatSection from './ChatSection/ChatSection';
import './App.css';

export default function App() {
  return (
    <div className="App">
      <Nav />
      <ChatSection />
    </div>
  );
}




